/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEmergingTechnologies = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M4 12a8 8 0 0 0 7.75 7.996L12 20v2c-5.429 0-9.848-4.327-9.996-9.72L2 12zm8-7a7 7 0 1 1 0 14 7 7 0 0 1 0-14zm.97 8h-1.94c.066 1.124.244 2.144.505 2.926.148.446.315.784.472.984L12 16.899l.06-.083c.114-.17.231-.41.34-.705l.065-.185c.26-.782.439-1.802.506-2.925zm-3.946 0-1.924.001a5.008 5.008 0 0 0 2.463 3.366c-.295-.95-.477-2.104-.539-3.366zm7.876.001h-1.924c-.062 1.262-.244 2.415-.539 3.366a5.01 5.01 0 0 0 2.463-3.366zM12 2c5.429 0 9.848 4.327 9.996 9.72L22 12h-2a8 8 0 0 0-7.75-7.996L12 4zM9.562 7.633l-.144.084A5.006 5.006 0 0 0 7.1 11h1.924c.062-1.262.243-2.415.538-3.367zM12 7.101l-.06.083a3.827 3.827 0 0 0-.405.89c-.261.782-.439 1.803-.506 2.926h1.942c-.067-1.123-.245-2.144-.506-2.926-.148-.446-.315-.784-.472-.984zm2.437.532.033.108c.276.93.446 2.045.506 3.26L16.9 11a5.008 5.008 0 0 0-2.463-3.367z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgEmergingTechnologies as EmergingTechnologies };
